import { Stripe } from '@stripe/stripe-js'
import { IClientInfo } from '../../models/clientInfo'

export enum ConfigurationTypeKeys {
  CHANGE_LANGUAGE = 'CHANGE_LANGUAGE',
  FETCH_AREAS = 'FETCH_AREAS',
  FETCHING_AREAS = 'FETCHING_AREAS',
  FETCH_AREAS_SUCCESSFUL = 'FETCH_AREAS_SUCCESSFUL',
  SET_SELECTED_AREA = 'SET_SELECTED_AREA',
  FETCH_CLIENT_INFO = 'FETCH_CLIENT_INFO',
  FETCHING_CLIENT_INFO = 'FETCHING_CLIENT_INFO',
  FETCH_CLIENT_INFO_SUCCESSFUL = 'FETCH_CLIENT_INFO_SUCCESSFUL',
  SET_AREA_CHANGED = 'SET_AREA_CHANGED',
  RESET_AREA_CHANGED = 'RESET_AREA_CHANGED',
  SET_STRIPE = 'SET_STRIPE',
  CHECK_IF_SHOW_PAYMENT_METHOD = 'CHECK_IF_SHOW_PAYMENT_METHOD',
  SET_SHOW_PAYMENT_METHOD = 'SET_SHOW_PAYMENT_METHOD'
}

export interface IChangeLanguageAction {
  type: typeof ConfigurationTypeKeys.CHANGE_LANGUAGE
  payload: string
}

export interface IFetchAreasAction {
  type: typeof ConfigurationTypeKeys.FETCH_AREAS
}

export interface ISetIsFetchingAreasAction {
  type: typeof ConfigurationTypeKeys.FETCHING_AREAS
}

export interface IFetchAreasSuccessfulAction {
  type: typeof ConfigurationTypeKeys.FETCH_AREAS_SUCCESSFUL
  payload: any[]
}

export interface IFetchClientInfoAction {
  type: typeof ConfigurationTypeKeys.FETCH_CLIENT_INFO
}

export interface ISetIsFetchingClientInfoAction {
  type: typeof ConfigurationTypeKeys.FETCHING_CLIENT_INFO
}

export interface IFetchClientInfoSuccessfulAction {
  type: typeof ConfigurationTypeKeys.FETCH_CLIENT_INFO_SUCCESSFUL
  payload: IClientInfo
}

export interface ISetSelectedAreaAction {
  type: typeof ConfigurationTypeKeys.SET_SELECTED_AREA
  payload: number
}
export interface ISetAreaChangedAction {
  type: typeof ConfigurationTypeKeys.SET_AREA_CHANGED
}

export interface IResetAreaChangedAction {
  type: typeof ConfigurationTypeKeys.RESET_AREA_CHANGED
}

export interface ISetStripeAction {
  type: typeof ConfigurationTypeKeys.SET_STRIPE,
  payload: Stripe
}

export interface ICheckIfShowPaymentMethodAction {
  type: typeof ConfigurationTypeKeys.CHECK_IF_SHOW_PAYMENT_METHOD
}

export interface ISetShowPaymentMethodAction {
  type: typeof ConfigurationTypeKeys.SET_SHOW_PAYMENT_METHOD,
  payload: boolean
}

export type ConfigurationActionTypes =
  | IChangeLanguageAction
  | IFetchAreasAction
  | ISetIsFetchingAreasAction
  | IFetchAreasSuccessfulAction
  | ISetSelectedAreaAction
  | IFetchClientInfoSuccessfulAction
  | ISetAreaChangedAction 
  | IResetAreaChangedAction
  | ISetStripeAction
  | ICheckIfShowPaymentMethodAction
  | ISetShowPaymentMethodAction
